<template>
  <div class="main">
    <transition name="fade-card" mode="out-in">
      <v-card class="card" color="#DC143C" v-if="language === 'mk'">
        <v-card-title>Мени</v-card-title>
      </v-card>
      <v-card class="card" color="#DC143C" v-else-if="language === 'en'">
        <v-card-title>Menu</v-card-title>
      </v-card>
      <v-card class="card" color="#DC143C" v-else-if="language === 'al'">
        <v-card-title>Menyja</v-card-title>
      </v-card>
    </transition>
    <lang-comp @toggle-language="setLanguage"></lang-comp>
    <transition name="fade-card" mode="out-in">
      <mk-menu v-if="language === 'mk'"></mk-menu>
      <en-menu v-else-if="language === 'en'"></en-menu>
      <al-menu v-else-if="language === 'al'"></al-menu>
    </transition>
  </div>
</template>

<script>
import LangComp from "@/components/LangComp.vue";
import EnMenu from "@/components/en/EnMenu.vue";
import MkMenu from "@/components/mk/MkMenu.vue";
import AlMenu from "@/components/al/AlMenu.vue";

export default {
  components: { LangComp, EnMenu, MkMenu, AlMenu },
  data() {
    return {
      language: "mk",
    };
  },
  methods: {
    setLanguage(lang) {
      this.language = lang;
    },
  },
  created() {
    if (this.$router.options.history.state.forward) {
      const langValue = this.$router.options.history.state.forward.split('/')[2];
      if(langValue) {
        this.language = langValue;
      }
      else {
        this.language = 'mk';
      }
    } else {
      if(this.$router.options.history.state.back){
        const backValue = this.$router.options.history.state.back.split('/')[2];
        if(backValue){
          this.language = backValue;
        }else {
          this.language = 'mk';
        }

      }
    }
  }
};
</script>

<style scoped>
.card {
  border-radius: 12px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.99);
  padding: 0.3rem;
  margin: 2rem auto;
  max-width: 18rem;
  text-align: center;
}
.main {
  min-height: 100vh;
  background: transparent;
}
.fade-card-enter-from,
.fade-card-leave-to {
  opacity: 0;
}
.fade-card-enter-active {
  transition: all 0.4s ease-out;
}
.fade-card-leave-active {
  transition: all 0.4s ease-in;
}

.fade-card-enter-to,
.fade-card-leave-from {
  opacity: 1;
}
</style>
